import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: 'moi-risk-summary',
    templateUrl: './moi-risk-summary.component.html',
    styleUrls: ['./moi-risk-summary.component.scss'],
    imports: [TranslatePipe, InputTooltipDirective],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiRiskSummaryComponent {
  private tabservice = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() riskGuid: any;

  openRisk() {
      if (!this.riskGuid || !this.summaryModel.CanOpenParent) {
          return;
      }

      this.tabservice.generateTab(this.pages.RiskDetail, this.riskGuid);
  }
}
